import React, { useEffect } from "react";

import TierLists from "./TierLists";
import BuildsAndRunes from "./BuildsAndRunes";

const FilterPreferences = (props) => {
  const { setPage } = props;

  useEffect(() => {
    setPage("League of Legends");
  }, []);
  return (
    <div className="settings-route-page settings_filters-preferences">
      <TierLists {...props} />
      <BuildsAndRunes {...props} />
    </div>
  );
};

export default FilterPreferences;
